const defaultDegrees = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
];

const cartialgeLessionDegrees = [
  {
    label: "0",
    value: 0,
  },
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
];

const synovitisDegrees = [
  {
    label: "0",
    value: 0,
  },
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
];

const compressionFractureDegrees = [
  {
    label: "0",
    value: 0,
  },
  {
    label: "1",
    value: 1,
  },
];

const spondylolisthesisDegrees = [
  {
    label: "0",
    value: 0,
  },
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
];

const degrees: Record<string, { label: string; value: number }[]> = {
  noSelected: [],
  cartialgeLession: cartialgeLessionDegrees,
  subchondralCyst: defaultDegrees,
  boneMarrowLesion: defaultDegrees,
  synovitis: synovitisDegrees,
  compressionFracture: compressionFractureDegrees,
  declineIntervertebralDiscs: [],
  marginalBoneGrowths: [],
  subchondralOsteochondrosis: [],
  spondylolisthesis: spondylolisthesisDegrees,
};

export default degrees;
